var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgviewerCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.001 502.001",
    style: {
      enableBackground: "new 0 0 502.001 502.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4EC9DC"
    },
    d: "M421.02,218.811l-86.219,86.219c10.819,19.512,31.616,32.725,55.508,32.725 c35.035,0,63.436-28.401,63.436-63.436C453.745,250.427,440.532,229.63,421.02,218.811z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.919,
    y: 407.081,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 323.2949 70.567)",
    style: {
      fill: "#4EC9DC"
    },
    width: 151.093,
    height: 36.908
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1E2EB"
    },
    points: "221.232,418.599 492,147.831 354.169,10 83.401,280.768 120.102,317.469 80.954,356.616  37.729,357.431 36.098,359.063 142.937,465.902 144.568,464.271 145.384,421.046 184.531,381.898  "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.7,192.956L213.345,337.311c-3.905,3.905-3.905,10.237,0,14.143c1.953,1.953,4.512,2.929,7.071,2.929 s5.119-0.976,7.071-2.929l144.355-144.355c3.905-3.905,3.905-10.237,0-14.143C367.936,189.05,361.606,189.05,357.7,192.956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.408,142.391c-3.906-3.905-10.236-3.905-14.143,0l-17.942,17.942c-3.905,3.905-3.905,10.237,0,14.143 c1.953,1.953,4.512,2.929,7.071,2.929s5.118-0.976,7.071-2.929l17.942-17.942C426.313,152.628,426.313,146.296,422.408,142.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5,418.872h-44.405c-24.695,0-44.786-20.091-44.786-44.786v-27.03c35.777-4.895,63.437-35.638,63.437-72.738 c0-22.301-10.146-43.158-27.12-56.97l62.446-62.447c1.875-1.875,2.929-4.419,2.929-7.071s-1.054-5.196-2.929-7.071L361.24,2.929 c-3.906-3.905-10.236-3.905-14.143,0L76.33,273.697c-3.905,3.905-3.905,10.237,0,14.142l29.63,29.63l-29.225,29.224l-39.193,0.74 c-2.585,0.049-5.052,1.097-6.881,2.926l-1.628,1.627c-0.002,0.002-0.003,0.003-0.005,0.005L2.929,378.089 c-3.905,3.905-3.905,10.237,0,14.143l106.839,106.839c1.953,1.953,4.512,2.929,7.071,2.929s5.119-0.976,7.071-2.929l26.098-26.098 l1.631-1.631c1.829-1.83,2.878-4.296,2.927-6.882l0.74-39.194l29.224-29.225l29.63,29.63c1.875,1.875,4.419,2.929,7.071,2.929 s5.196-1.054,7.071-2.929l105.035-105.035c11.724,14.407,28.521,23.894,46.97,26.434v27.018c0,35.723,29.063,64.786,64.786,64.786 H489.5c5.522,0,10-4.477,10-10S495.022,418.872,489.5,418.872z M116.839,477.858l-92.697-92.697l11.956-11.956l92.697,92.697 L116.839,477.858z M138.313,413.975c-1.829,1.829-2.878,4.296-2.927,6.882l-0.433,22.918l-76.729-76.729l22.918-0.433 c2.586-0.049,5.053-1.098,6.882-2.927L120.1,331.61l50.288,50.288L138.313,413.975z M97.543,280.768L354.169,24.142 L477.857,147.83L221.232,404.457L97.543,280.768z M422.386,231.587c13.329,10.019,21.359,25.806,21.359,42.731 c0,29.465-23.972,53.437-53.437,53.437c-16.925,0-32.712-8.03-42.73-21.359L422.386,231.587z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerCctv);
export default __webpack_public_path__ + "static/media/svgviewer-cctv.acb7ef3c4ee8f7d221cb1a871db3a76d.svg";
export { ForwardRef as ReactComponent };